export default __webpack_public_path__ + "static/media/icon-modal-close.1c005b15.svg";